import { css } from 'styled-components';

export const fastclick = css`
  html,
  body {
    -webkit-tap-highlight-color: transparent;
  }
`;
